<template>
  <div class="items">
    <div class="item">
      <div class="check">
        <input
          :id="item.id"
          type="checkbox"
          :checked="item?.content?.startNewPage"
          @change="value => itemChanged(value.target.checked, 'startNewPage')"
        />
        <label :for="item.id">{{ $t('editor.newPage') }}</label>
      </div>
      <div class="text">{{ $t('editor.skills.name') }}</div>
      <FireArea
        ref="name-field"
        :small-height="true"
        :template-div-container="'name'"
        :value="item.content.name"
        @change="value => itemChanged(value, 'name')"
      />
    </div>
    <div class="item">
      <div class="text">{{ $t('editor.skills.values') }}</div>
      <FireArea
        ref="values-field"
        :small-height="true"
        :template-div-container="'values'"
        :value="item.content.values"
        @change="value => itemChanged(value, 'values')"
      />
    </div>
  </div>
</template>

<script>
import FireArea from '@/components/inputs/FireArea';
export default {
  name: 'SkillPanel',
  components: {
    FireArea,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dontSendNext: false,
    };
  },
  methods: {
    updateFields() {
      this.dontSendNext = true;
      this.$refs['name-field'].input = this.item.content.name;
      this.dontSendNext = true;
      this.$refs['values-field'].input = this.item.content.values;
    },
    itemChanged(value, key) {
      if (this.dontSendNext) {
        this.dontSendNext = false;
        return;
      }
      if (this.items?.length) {
        const content = JSON.parse(JSON.stringify(this.items[0].content));
        content[key] = value;
        this.$store.dispatch('items.content.edit', {
          itemId: this.items[0].id,
          content,
        });
      } else if (this.item) {
        const content = JSON.parse(JSON.stringify(this.item.content));
        content[key] = value;
        this.$store.dispatch('items.content.edit', {
          itemId: this.item.id,
          content,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/inspector.scss';
@use '@/styles/utils.scss';
@use '@/styles/colors.scss';

.check {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  label {
    margin-left: 4px;
    user-select: none;
    display: block;
    @extend .uppercase-first;
    color: colors.$dark-grey-color;
    cursor: pointer;
  }
}

.text {
  @extend .uppercase-first;
}

.panel {
  .content {
    .section {
      .items {
        .item {
          padding-right: 0;
        }
      }
    }
  }
}
</style>
